import { Emitter } from '../../utils';
export var eventEmitter = new Emitter();
var LoginExpiry = /** @class */ (function () {
    function LoginExpiry() {
    }
    LoginExpiry.show = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        console.log(args, 'arguments to show');
        eventEmitter.fire('showLoginExpiry', args);
    };
    LoginExpiry.hide = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        console.log(args, 'arguments to hide');
        eventEmitter.fire('hideLoginExpiry', args);
    };
    return LoginExpiry;
}());
export default LoginExpiry;
//# sourceMappingURL=loginExpiry.js.map